var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('el-tree',{attrs:{"props":_vm.defaultProps,"data":_vm.ditree,"lazy":"","expand-on-click-node":false,"load":_vm.loadNode},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }